export default "__VITE_ASSET__1785fd59__"